// ExportTemplateButton.tsx
import React, { useCallback } from "react";
import { Button } from "@mantine/core";
import { openapi } from "../../../../openapi";
import { base64TilBlob } from "./redux/checklistThunks";
// Viktig: importera createApi-instansen från din OpenAPI-bundle

type Props = {
  checklistLocalId?: number;
};

// trigger download via anchor
function saveBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export const ExportChecklistButton: React.FC<Props> = ({ checklistLocalId }) => {
  // Lazy query via endpoint (bästa sättet när api-objektet exporteras)
  const [trigger, { isFetching }] = openapi.endpoints.getChecklistByChecklistIdExport.useLazyQuery();

  const onClick = useCallback(async () => {
    if (!checklistLocalId) return;
    try {
      const res = await trigger({ checklistId: checklistLocalId, excel: true }).unwrap();
      if (res?.excel) {
        const blob = base64TilBlob(res.excel.base64, res.excel.contentType);
        saveBlob(blob, res.excel.filename);
      } else {
        console.warn("Ingen Excel-data i svaret.", res);
      }
    } catch (err) {
      console.error("Klarte ikke å eksportere sjekkliste:", err);
    }
  }, [checklistLocalId, trigger]);

  return (
    <Button onClick={onClick} loading={isFetching} disabled={!checklistLocalId}>
      Eksporter til Excel
    </Button>
  );
};

export default ExportChecklistButton;
